/**
 * Custom hook for swipe gesture detection
 * Used for mobile-first swipe interactions (Closet section)
 */

import { useState, useEffect, useRef } from 'react';

export const useSwipeGesture = (callback, options = {}) => {
  const {
    minSwipeDistance = 50,
    maxSwipeTime = 300,
    preventDefaultTouchmoveEvent = false,
  } = options;

  const touchStartRef = useRef(null);
  const touchEndRef = useRef(null);

  const onTouchStart = (e) => {
    if (preventDefaultTouchmoveEvent) {
      e.preventDefault();
    }
    touchStartRef.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      time: Date.now(),
    };
  };

  const onTouchMove = (e) => {
    touchEndRef.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
  };

  const onTouchEnd = () => {
    if (!touchStartRef.current || !touchEndRef.current) return;

    const deltaX = touchEndRef.current.x - touchStartRef.current.x;
    const deltaY = touchEndRef.current.y - touchStartRef.current.y;
    const deltaTime = Date.now() - touchStartRef.current.time;

    const isSwipe =
      (Math.abs(deltaX) > minSwipeDistance || Math.abs(deltaY) > minSwipeDistance) &&
      deltaTime < maxSwipeTime;

    if (isSwipe) {
      const direction = Math.abs(deltaX) > Math.abs(deltaY)
        ? (deltaX > 0 ? 'right' : 'left')
        : (deltaY > 0 ? 'down' : 'up');

      callback(direction, { deltaX, deltaY, deltaTime });
    }

    touchStartRef.current = null;
    touchEndRef.current = null;
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};

export default useSwipeGesture;
